/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, {useState, useEffect} from 'react';

export const IdentityContext = React.createContext();

export default function IdentityProvider({ children }) {
  const prevAuthToken = window.localStorage.getItem('authToken') || null;
  const prevAuthUser = window.localStorage.getItem('authUser') || null;

  const [isAuthenticated, setIsAuthenticated] = useState(false); // every session has to be authenticated
  const [authToken, setAuthToken] = useState(prevAuthToken);
  const [authUser, setAuthUser] = useState(prevAuthUser);

  useEffect(() => {
    window.localStorage.setItem('authToken', authToken);
    window.localStorage.setItem('authUser', authUser);
  }, [authToken, authUser]);

  const defaultContext = {
    isAuthenticated,
    setIsAuthenticated,
    authUser,
    setAuthUser,
    authToken,
    setAuthToken
  };

  return (
    <IdentityContext.Provider value={defaultContext}>
      {children}
    </IdentityContext.Provider>
  );
}
